import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { Button } from '../../../Button';
import { styleSheet } from '../styles';

type Params = {
	originalAttachment: Api.IFileAttachment;
	brandedAttachment: Api.IFileAttachment | null;
	selected: boolean;
	setSelected: (attachment: Api.IFileAttachment) => void;
	onCancel: () => void;
};

export const ImageRow = ({ originalAttachment, brandedAttachment, onCancel }: Params) => {
	return (
		<div className={css(styleSheet.imageRow)}>
			<figure className={css(styleSheet.resultImageContainer)}>
				<img src={originalAttachment?.url} alt={originalAttachment?.fileName} className={css(styleSheet.image)} />
				<figcaption className={css(styleSheet.resultImageLabel, styleSheet.resultImageLabelOriginal)}>
					Original
				</figcaption>
			</figure>

			<figure className={css(styleSheet.resultImageContainer)}>
				<img src={brandedAttachment?.url} alt={brandedAttachment?.fileName} className={css(styleSheet.image)} />
				<figcaption className={css(styleSheet.resultImageLabel)}>Branding Added</figcaption>
			</figure>

			<div className={css(styleSheet.actionsContainer)}>
				<Button variant='secondary' size='sm' onClick={() => onCancel()}>
					Cancel Changes
				</Button>
			</div>
		</div>
	);
};
